import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { kebabCase } from 'lodash'
import { SearchOrderStatus } from 'config/search-services'
import {
  ServicesAgreementStatus,
  RolloverAccountStatus,
} from 'config/automatic-rollovers'
import {
  OrderStatus,
  BDCombinedAgreementStatus,
} from 'config/benefit-distributions'
import { NotificationStatuses } from '../config/notification-services'
import { Icon as AlertIcon } from 'images/status-icons/alert.svg'
import { Icon as ClockIcon } from 'images/status-icons/clock.svg'
import { Icon as PencilIcon } from 'images/status-icons/edit.svg'
import { Icon as ChecklistIcon } from 'images/status-icons/checklist.svg'
import { Icon as FileRecievedIcon } from 'images/status-icons/document.svg'
import { Icon as FundingIcon } from 'images/status-icons/cheque.svg'
import { Icon as NotAcceptedIcon } from 'images/status-icons/x-with-circle.svg'
import { Icon as SuccessIcon } from 'images/status-icons/checkmark-green.svg'
import { Icon as InProgressIcon } from 'images/status-icons/clock-new.svg'
import { Icon as AlertCircleIcon } from 'images/status-icons/alert-circle.svg'
import { Icon as EvelopeIcon } from 'images/status-icons/envelope.svg'

const propTypes = {
  status: PropTypes.string.isRequired,
}

const defaultProps = {}

const getStatusIcon = (status) => {
  switch (status) {
    case ServicesAgreementStatus.COMPLETED:
    case SearchOrderStatus.RESULTS_AVAILABLE:
    case RolloverAccountStatus.ROLLOVER_COMPLETE:
    case BDCombinedAgreementStatus.COMBINED_COMPLETED:
    case OrderStatus.COMPLETED:
    case NotificationStatuses.DELIVERED:
      return SuccessIcon
    case ServicesAgreementStatus.IN_REVIEW:
    case SearchOrderStatus.IN_PROGRESS:
    case RolloverAccountStatus.PROCESSING:
    case BDCombinedAgreementStatus.COMBINED_IN_REVIEW:
    case OrderStatus.IN_PROGRESS:
    case NotificationStatuses.IN_PROGRESS:
      return InProgressIcon
    case ServicesAgreementStatus.PENDING_SIGNATURES:
    case BDCombinedAgreementStatus.COMBINED_PENDING_SIGNATURES:
      return PencilIcon
    case SearchOrderStatus.FAILED:
      return AlertIcon
    case RolloverAccountStatus.READY_FOR_FUNDING:
      return ChecklistIcon
    case OrderStatus.FUNDING_RECEIVED:
      return FundingIcon
    case OrderStatus.FILE_RECIEVED:
      return FileRecievedIcon
    case OrderStatus.NOT_ACCEPTED:
    case NotificationStatuses.NOT_DELIVERED:
      return NotAcceptedIcon
    case SearchOrderStatus.RESULTS_EXPIRED:
      return ClockIcon
    case NotificationStatuses.RETURN:
      return AlertCircleIcon
    case NotificationStatuses.SENT:
      return EvelopeIcon
    default:
      return () => null
  }
}

function StatusBadge({ status }) {
  const StatusIcon = getStatusIcon(status)
  return (
    <span className={classnames('status', `badge--${kebabCase(status)}`)}>
      <StatusIcon aria-hidden="true" />
      {status}
    </span>
  )
}

StatusBadge.propTypes = propTypes
StatusBadge.defaultProps = defaultProps

export default StatusBadge
